import { render } from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=template&id=398fc050&scoped=true"
import script from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=script&lang=js"
export * from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=script&lang=js"

import "./ReportQuickDiagnosisSelectionTab.vue?vue&type=style&index=0&id=398fc050&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398fc050"]])

export default __exports__